var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
import { getStatusColor } from '../../utils/color';
let SimpleWorkflowExecutionCard = class SimpleWorkflowExecutionCard extends LitElement {
    constructor() {
        super(...arguments);
        this.selected = false;
        this.workflow = null;
    }
    updated(_changedProperties) {
        if (_changedProperties.has('workflowExecution')) {
            this.workflow = this.workflowExecution.workflow_saved;
        }
    }
    handleClick() {
        const event = new CustomEvent('select-workflow-execution', {
            detail: this.workflowExecution,
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
    render() {
        const { workflowExecution, selected } = this;
        if (!workflowExecution) {
            return html `<loading-div></loading-div>`;
        }
        const statusColor = getStatusColor(workflowExecution.status);
        return html `
      <basic-selectable-card
        .selected="${selected}"
        size="small"
        @card-clicked="${this.handleClick}"
      >
        <div class="header">
          <h3 class="title">${this.workflow ? this.workflow.name : msg('Unknown workflow', { id: 'workflowExecutionCard.unknownWorkflow', desc: 'Title shown when the workflow for an execution cannot be resolved' })}</h3>
          <span class="status">
            <basic-status
              .status="${workflowExecution.status.toUpperCase()}"
              .variant="${statusColor}"
              .size="${'small'}"
            ></basic-status>
          </span>
        </div>
        <p class="subtitle">${msg('Execution ID:', { id: 'workflowExecutionCard.executionId', desc: 'Label preceding the workflow execution id' })} <b>${workflowExecution.workflow_execution_id}</b> | ${workflowExecution.created_by}</p>
        <p class="started-at">${msg('Started:', { id: 'workflowExecutionCard.started', desc: 'Label preceding the workflow execution start date' })} <span>${new Date(workflowExecution.started_at).toLocaleString()}</span></p>
        <p class="finished-at">${msg('Finished:', { id: 'workflowExecutionCard.finished', desc: 'Label preceding the workflow execution finish date' })} <span>${workflowExecution.finished_at ? new Date(workflowExecution.finished_at).toLocaleString() : msg('In progress', { id: 'workflowExecutionCard.inProgress', desc: 'Shown in place of the finish date while a workflow execution is still running' })}</span></p>
      </basic-selectable-card>
    `;
    }
};
SimpleWorkflowExecutionCard.styles = css `
    :host {
      display: block;
    }
    basic-selectable-card {
      display: block;
      position: relative;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.3rem;
    }
    .title {
      font-size: 0.85rem;
      font-weight: 700;
      margin: 0;
      color: #222;
      letter-spacing: 0.01em;
    }
    .status {
      margin-left: 0.5rem;
      flex-shrink: 0;
    }
    .subtitle {
      font-size: 0.78rem;
      color: #666;
      margin: 0 0 0.15rem 0;
      font-weight: 500;
    }
    .started-at, .finished-at {
      font-size: 0.75rem;
      color: #888;
      margin: 0 0 0.1rem 0;
    }
    .finished-at {
      margin-bottom: 0;
    }
  `;
__decorate([
    property({ type: Object })
], SimpleWorkflowExecutionCard.prototype, "workflowExecution", void 0);
__decorate([
    property({ type: Boolean })
], SimpleWorkflowExecutionCard.prototype, "selected", void 0);
__decorate([
    state()
], SimpleWorkflowExecutionCard.prototype, "workflow", void 0);
SimpleWorkflowExecutionCard = __decorate([
    localized(),
    customElement('simple-workflow-execution-card')
], SimpleWorkflowExecutionCard);
export { SimpleWorkflowExecutionCard };
//# sourceMappingURL=SimpleWorkflowExecutionCard.js.map